import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, useTheme } from "@mui/material";

const AdminActionButton = ({ name, icon, routeName }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const onClick = () => {
    navigate(`/admin/${routeName}`);
  };

  return (
    <Box sx={{ m: 2 }}>
      <Button
        onClick={onClick}
        sx={{
          width: 175,
          height: 175,
          p: 2,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.accent.main,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: 2,
          boxShadow: 2,
          transition: "background-color 0.2s ease",
          whiteSpace: "normal",         // allow wrapping
          textAlign: "center",          // center multiline
          "&:hover": {
            backgroundColor: theme.palette.background.paper + "D9",
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            mb: 1,
          }}
        >
          {name}
        </Typography>
        <Box sx={{ fontSize: 50 }}>{icon}</Box>
      </Button>
    </Box>
  );
};

export default AdminActionButton;